<script setup lang="ts">
import { computed } from 'vue';
import { AssessmentQuestion, AssessmentAnswerDetail } from '../../../../../types/assessment';
import { UserRole } from '../../../../../types/user';
import { useClassStore, useUserStore } from '../../../../../stores';

import RenderQuestion from '../components/QuizQuestionContent.vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../../../configs/text';
import Katex from '../../../../General/Katex.vue';
import QuizMcqChoices from '../components/QuizMcqChoices.vue';

interface Props {
    question: AssessmentQuestion
    disabled?: boolean
    showAnswer?: boolean
    showSubmission?: boolean
    useColor?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    showAnswer: false,
    disabled: false,
    showSubmission: false,
    useColor: false
})

const { t } = useI18n();
const userStore = useUserStore();
const classStore = useClassStore();


const submitedAnswer = computed<AssessmentAnswerDetail[]>(() => {
    const question = classStore.currentStudent?.quizQuestion?.find((question) => question.id === props.question.id);
    return question ? question.answer : [];
});

const answers = defineModel<string[]>('answers', { default: [] })
answers.value = submitedAnswer.value?.map((item) => item.answer) || []

const isSubmitted = computed<boolean>(() => {
    return classStore.currentStudent?.quizQuestion?.some(answer => answer.id == props.question.id) ? true : false
})


function handleAnswerChange(studentAnswers: string[]) {
    if (userStore.userRole === UserRole.teacher) {
        // Nếu người dùng là giáo viên, không cho phép thay đổi câu trả lời
        return;
    }
    answers.value = studentAnswers;
}


</script>
<template>
    <Katex class="flex gap-1 px-1 py-1 md:px-3 lg:px-6 lg:py-2 md:gap-3 flex-col w-full h-full justify-between overflow-auto md:overflow-hidden">
        <RenderQuestion class="grow h-3/5" layout="horizontal" :question="question" :showAnswer="showAnswer" />
        <div class="flex grow shrink-0 h-2/5 flex-col">
            <QuizMcqChoices :question="question" :answers="answers" :showAnswers="showAnswer" :showSubmission="showSubmission" :disabled="props.disabled || isSubmitted" @change="handleAnswerChange" />
        </div>
        <div class="w-full first-letter:uppercase" v-if="question.explanation && question.explanation.length > 0 && showAnswer && userStore.userRole === UserRole.student">
            <span class="font-bold">{{ t(TEXT.explanation) }}:</span>
            <div v-html="question.explanation"></div>
        </div>
    </Katex>
</template>